import * as React from "react";
import { Card } from 'semantic-ui-react';

interface IProps {
    componentName?: string;
}

export class Dashboard extends React.Component<IProps> {

    constructor(props: IProps){
        super(props)
    }

    public render() {
        return (
            <Card fluid={true}>
                <Card.Content>
                    <Card.Header>Selamat Datang!</Card.Header>
                    <Card.Meta>Administrator</Card.Meta>
                    <Card.Description>Silahkan mengelola data dengan baik dan benar.</Card.Description>
                </Card.Content>
            </Card>
        );
    }
}


// WEBPACK FOOTER //
// ./src/screen/admin/dashboard/Dashboard.tsx